var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.509,
    height: 17,
    viewBox: "0 0 15.509 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "home_FILL0_wght300_GRAD0_opsz24",
    d: "M181.552-782.242h3.46v-5.209a.9.9,0,0,1,.269-.666.9.9,0,0,1,.666-.269h3.619a.9.9,0,0,1,.666.269.9.9,0,0,1,.269.666v5.209h3.46v-9.146a.3.3,0,0,0-.035-.144.387.387,0,0,0-.094-.114l-5.885-4.424a.277.277,0,0,0-.189-.07.277.277,0,0,0-.189.07l-5.885,4.424a.387.387,0,0,0-.094.114.3.3,0,0,0-.035.144Zm-1.551,0v-9.146a1.856,1.856,0,0,1,.2-.841,1.792,1.792,0,0,1,.549-.654l5.885-4.434a1.8,1.8,0,0,1,1.12-.374,1.81,1.81,0,0,1,1.123.374l5.885,4.434a1.792,1.792,0,0,1,.549.654,1.856,1.856,0,0,1,.2.841v9.146a1.492,1.492,0,0,1-.458,1.093,1.492,1.492,0,0,1-1.093.458h-4.076a.9.9,0,0,1-.666-.269.9.9,0,0,1-.269-.666v-5.209h-2.386v5.209a.9.9,0,0,1-.269.666.9.9,0,0,1-.666.269h-4.076a1.492,1.492,0,0,1-1.093-.458A1.492,1.492,0,0,1,180-782.242ZM187.755-789.2Z",
    transform: "translate(-180.001 797.691)",
    fill: "#072635"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.9721604287b838f7bb2d308da7ad58c0.svg";
export { ForwardRef as ReactComponent };